import * as React from 'react';

const CoinsIcon = (props) => (
  <svg fill="none" viewBox="0 0 16 16" width={16} height={17} {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6.5c3.038 0 5.5-1.12 5.5-2.5S11.038 1.5 8 1.5 2.5 2.62 2.5 4 4.962 6.5 8 6.5M2.5 6.5V7c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-.5M2.5 9.5v.5c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-.5M2.5 12.5v.5c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-.5"
    />
  </svg>
);

export default CoinsIcon;
